import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import LoginView from './loginView';
import {getCookie, setCookie} from "../../utils/cookies";
import {loginUserAction} from "../../redux/auth/reducer";
import {tracker} from "../../utils/tracker";
import qs from 'query-string';
import { enqueueSnackbar, closeSnackbar } from 'notistack'
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import {messages} from "../../utils/constants";
import {getUserService} from "../../redux/user/requests";
import {saveUserSession} from "../../utils/user";
import {DASHBOARD} from "../../utils/navigation";
import {BAD_REQUEST, FORBIDDEN} from "../../utils/serverCode";

class LoginComponent extends Component {
    state = {
        isSuccess: false,
        message: '',
        snackbar_open: false,
        loading: false,
    };

    closeSnackbarD = key => {
        closeSnackbar(key);
    };
    componentDidMount(){
        document.title = 'Social BlueBook - Login';
        const action = key => (
            <Fragment>
                <IconButton onClick={() => { this.closeSnackbarD(key) }} style={{color:'white'}}>
                    <CloseIcon />
                </IconButton>
            </Fragment>
        );
        const parsed = qs.parse(location.search);
        if(parsed['error']){
            this.key = enqueueSnackbar(messages[parsed['error']], {
                variant: 'error',
                autoHideDuration: 10000,
                action
            });
        }

        setTimeout(()=>{
            if(getCookie('id') !== ''){
                getUserService().then(result=>{
                    if(saveUserSession(result)){
                        // check where the user should go:
                        window.location = this.props.redirect ? this.props.redirect : DASHBOARD
                    }
                });
            }
        }, 30);
    }

    onHandleLogin = (event) => {
        event.preventDefault();
        let username = event.target.username.value;
        let password = event.target.password.value;
        let distinct_id = false
        try {
            if(window.mixpanel){
                distinct_id = window.mixpanel?.cookie?.props?.distinct_id;
            }
        }
        catch (e){}

        const data = {
            username, password, distinct_id
        };

        this.setState({snackbar_open: true, loading: true});
        this.props.dispatch(loginUserAction(data));
    };

    handleSnacks = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({snackbar_open: false});
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.response.login.hasOwnProperty('response')) {
            if (nextProps.response.login.response.status === 200 ){
                if (nextProps.response.login.response.status === 200 !== prevState.isSuccess) {
                    if(nextProps.response.login.response && nextProps.response.login.response.data.hasOwnProperty('id')){

                        tracker("User logged in",
                            {
                                'action' : 'User logged in',
                                'eventCategory': 'Auth',
                                'eventAction': 'User logged in',
                                'email': nextProps.response.login.response.data['email'],
                                'total_reach': nextProps.response.login.response.data['total_reach'],
                                'paid': nextProps.response.login.response.data['active_subscription'],
                            });

                        for(let tour of nextProps.response.login.response.data['user_tutorials']){
                            localStorage.setItem(tour.name, JSON.stringify(tour.finished));
                        }

                        setCookie('role', nextProps.response.login.response.data.role, 24*14);
                        setCookie('id', nextProps.response.login.response.data.id, 24*14);

                        localStorage.setItem('user', JSON.stringify(nextProps.response.login.response.data));
                        prevState.snackbar_open = false;
                    }
                    return {
                        isSuccess: nextProps.response.login.response.data.success,
                        message: nextProps.response.login.response.data.message,
                        loading: false
                    };
                } else {
                    return {
                        isSuccess: nextProps.response.login.response.status === 200,
                        message: nextProps.response.login.response.data.message,
                        loading: false
                    };
                }
            }else{
                // handle server error:
                if(prevState.isSuccess){
                    return null;
                }
                if (nextProps.response.login.response.status === FORBIDDEN || nextProps.response.login.response.status === BAD_REQUEST){
                    return {
                        isSuccess: false,
                        message: 'Authentication problems. Email or password is wrong',
                        loading: false
                    }
                }
                return null;
            }
        } else {
            //there is no state change detected
            return null;
        }
    }

    render() {
        return (
            <LoginView
                handleLogin={this.onHandleLogin}
                redirect={this.props.redirect}
                handleSnacks={this.handleSnacks}
                loading={this.state.loading}
                snackbar_open={this.state.snackbar_open}
                success={this.state.isSuccess}
                message={this.state.message} />
        );
    }
}

const mapStateToProps = (response) => ({response});

export default connect(mapStateToProps)(LoginComponent);
